import {
  Siren, ShieldAlert, Shield, Flame, Zap, Droplets, Users, HeartHandshake,
  Cross, Landmark, Biohazard, CloudSun, Route, Backpack, HeartPulse, Sprout,
  CloudRain, Wind, Activity, Thermometer, Phone, Search, Printer, RotateCcw,
  RefreshCw, Languages, Gauge, TriangleAlert, ChevronRight, ExternalLink,
  PhoneCall, MapPin, CheckCircle2, Circle, Waves, Sun, FileText, Info,
  Stethoscope, Ambulance, Share2, MessageCircle, Bell, BellOff,
  CircleHelp, Download, X, Volume2, VolumeX, Eye, Navigation,
} from "lucide-react";

const ICONS = {
  Siren, ShieldAlert, Shield, Flame, Zap, Droplets, Users, HeartHandshake,
  Cross, Landmark, Biohazard, CloudSun, Route, Backpack, HeartPulse, Sprout,
  CloudRain, Wind, Activity, Thermometer, Phone, Search, Printer, RotateCcw,
  RefreshCw, Languages, Gauge, TriangleAlert, ChevronRight, ExternalLink,
  PhoneCall, MapPin, CheckCircle2, Circle, Waves, Sun, FileText, Info,
  Stethoscope, Ambulance, Share2, MessageCircle, Bell, BellOff,
  CircleHelp, Download, X, Volume2, VolumeX, Eye, Navigation,
};

export function Icon({ name, className = "w-5 h-5", strokeWidth = 2 }) {
  const Cmp = ICONS[name] || Info;
  return <Cmp className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
}
